import api from "../../../../../../api";
import { useToast } from "../../../../../../mantine/notifications/useToast";
import urls from "../../../../../../urls";
import { pollTaskStatus } from "../../../../../../utils/api-utils";
import { downloadPDF } from "../../../../../../utils/downloadPdf";
import { getErrorText } from "../../../../../../utils/get-error-text";

interface UseDownloadVollmachtUrls {
  canGenerateUrl: (siteId: number) => string;
  generateUrl: (siteId: number) => string;
  getUrl: (siteId: number, taskId: string) => string;
}

function useDownloadVollmacht(
  siteId: number,
  vollmachtUrls: UseDownloadVollmachtUrls
) {
  const { showErrorToast } = useToast();

  async function generateAndDownloadVollmacht() {
    const response = await api.get<{
      canGenerateDocumentsAutomatically: boolean;
      documentGenerationBlocker: { message: string };
    }>(vollmachtUrls.canGenerateUrl(siteId));

    if (!response.data.canGenerateDocumentsAutomatically) {
      showErrorToast(response.data.documentGenerationBlocker.message);
      return;
    }

    const generateResponse = await api.get(vollmachtUrls.generateUrl(siteId));
    const taskId = generateResponse.data?.taskIds[0];
    if (!taskId) return;

    pollTaskStatus(
      urls.api.jobStatus(taskId),
      async () =>
        downloadPDF(await api.get(vollmachtUrls.getUrl(siteId, taskId))),
      (error) => showErrorToast(getErrorText(error))
    );
  }

  return { generateAndDownloadVollmacht };
}

export { useDownloadVollmacht };
